import React from 'react'
import PropTypes from "prop-types"
import { keys, isFunction, isObject, isString } from 'lodash'
import { post } from 'superagent'
import { findDOMNode } from 'react-dom'

import { Modal, Panel, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'

import Button from "../components/Button"
import { getFileExtension } from '../../lib/Tools.js'
import { getText } from '../lib/text.js'

const normalize = s => (s.match(/^\/static\/uploads\/.*/) ? s : `/static/uploads/${s}`)

class FilesSelector extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = { uploadingKeys: {} }
  }

  markUploading(k)   { this.setState({ uploadingKeys: { ...this.state.uploadingKeys, [k]: true }}) }

  unmarkUploading(k) { this.setState({ uploadingKeys: { ...this.state.uploadingKeys, [k]: false }}) }

  handleFile(value, fileKey, _evt) {
    // #TODO stop using the old findDOMNode method and react's ref
    const inputNode = findDOMNode(this.refs[`fileUpload_${fileKey}`])

    if (inputNode.files.length > 0) {
      const extensions = this.props.extensions[fileKey]
      const file = inputNode.files[0]

      if (extensions && extensions.length > 0
          && !extensions.includes(getFileExtension(file.name).toLowerCase()))
      {
        alert(`${getText("Extensión incorrecta. Esta extensión puede ser:")} ${extensions.join(", ")}.`)
        inputNode.value = null
        return
      }

      this.markUploading(fileKey)

      post(`/api/upload/${fileKey}`)
        .attach("file", file, file.name)
        .end((err, res) => {
          if (err) {
            console.error(res)
            console.error(err)
          }

          let path = res.body.path

          if (path.slice(0, 1) === ".") {
            path = path.slice(1)
          }

          this.props.onChange(
            { ...value, [fileKey]: path }
          )
          this.unmarkUploading(fileKey)
        })
    }
  }

  createNewKey() {
    // eslint-disable-next-line no-alert
    const input = prompt("Clave del nuevo fichero: (probablemente minúsculas, sin espacios)")

    if (input && isString(input)) {
      if (input in this.props.value) {
        // eslint-disable-next-line no-alert
        alert(`La clave ya existe! (Contiene ${Object.keys(this.props.value).join(", ")})`)
      }
      else {
        this.props.onChange({ ...this.props.value, [input]: null })
      }
    }
  }

  getLabel(k) {
    const { labels } = this.props
    return (
      (isFunction(labels) && labels(k))
      || (isObject(labels) && labels[k])
      || k || <i>[No name]</i>
    )
  }

  renderFile(k) {
    return (
      <span>
        <div style={{ display: "inline" }}>
          {"["}
          <a href={normalize(this.props.value[k])} download>
            <Button
              bsStyle="link" glyph="download" tooltipText="Descargar"
              onClick={() => console.log("Noop button")}
              style={{ padding: "5px 2px" }}
            />
          </a>
          {","}
          <a href={normalize(this.props.value[k])} target="_blank" rel="noopener noreferrer">
            <Button
              bsStyle="link" glyph="eye-open" tooltipText="Ver"
              style={{ padding: "5px 2px" }}
              onClick={() => console.log("Noop button")}
            />
          </a>
          {","}
          <Button
            bsStyle="link" tooltipText={getText("Quitar fichero")} glyph="remove"
            style={{ padding: "5px 2px" }}
            onClick={() => {
              if (confirm("¿Estás seguro?")) {
                this.props.onChange({ ...this.props.value, [k]: null })
                // #ÑAPA gran deshonor, muy horrible
                // al hacer los dos onchange, el segundo se recibe en el ancestro que va 
                // a ejecutar el cambio no ha recibido los resultados del primero
                // #TODO solve this in a way that doesn't bring shame to my people
                if (this.props.includeNotes) {
                  setTimeout(
                    () => this.props.onNotesChange({ ...this.props.fileNotes, [k]: "" }),
                    200
                  )
                  
                }
              }
            }}
          />
          {"]"}
        </div>
        <div style={{
          display: "inline-block",
          fontWeight: "bold",
          fontStyle: "italic",
          marginLeft: 5,
          minWidth: this.props.includeNotes ? 115 : 0,
        }}>
          {this.getLabel(k)}
        </div>
        {
          this.props.includeNotes && (
            <i style={{ marginLeft: 20 }}>
              (Nota:
              <input
                style={{ marginLeft: 5, marginRight: 1, border: "1px solid #999", borderRadius: 5 }}
                onChange={evt => this.props.onNotesChange({ ...this.props.fileNotes, [k]: evt.target.value })}
                value={this.props.fileNotes[k] || ""}
              />
              )
            </i>
          )
        }
      </span>
    )
  }

  render() {
    const { disabled, title } = this.props
    const files = this.props.value

    return (
      <div>
        { !this.state.spinning ? "" : (<Modal>Cargando...</Modal>) }

        <ControlLabel style={{ marginTop: 20 }}>{title || `${getText("Ficheros")}:`}</ControlLabel>
        <Panel style={disabled ? { backgroundColor: "#ddd" } : {}}>
          <Panel.Body>
            <ul>
              {
                keys(files).map(k => (
                  <li key={k}>
                    {
                      // eslint-disable-next-line no-nested-ternary
                      this.state.uploadingKeys[k]
                        ? (getText("Subiendo..."))
                        : (
                          this.props.value[k] && !disabled
                            ? (this.renderFile(k))
                            : (
                              <FormGroup>
                                <ControlLabel>{this.getLabel(k)}</ControlLabel>
                                <FormControl
                                  disabled={disabled}
                                  ref={`fileUpload_${k}`}
                                  type="file"
                                  onChange={evt => this.handleFile(files, k, evt)}
                                />
                              </FormGroup>
                            )
                        )
                    }
                  </li>
                ))
              }
            </ul>
            {
              this.props.allowNew && (
                <Button glyph="plus" onClick={() => this.createNewKey()}>Nuevo</Button>
              )
            }
          </Panel.Body>
        </Panel>

      </div>
    )
  }
}

FilesSelector.propTypes = {
  title: PropTypes.node.isRequired, // title: string
  onChange: PropTypes.func.isRequired, // onChange: Object => void,
  value: PropTypes.objectOf(PropTypes.string).isRequired,

  extensions: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)), // ej: { imagen: ["jpg"] }
  labels: PropTypes.oneOf([
    PropTypes.objectOf(PropTypes.node),
    PropTypes.func,
  ]),
  disabled: PropTypes.bool,
  allowNew: PropTypes.bool,

  includeNotes: PropTypes.bool,
  fileNotes: PropTypes.objectOf(PropTypes.string),
  onNotesChange: PropTypes.func,
}

FilesSelector.defaultProps = {
  labels: {},
  extensions: {},
  disabled: false,
  allowNew: false,
  includeNotes: false,
  fileNotes: {}
}

export default FilesSelector
